import { graphql } from '@/graphql/codegen';

export const GeneratePresignedUrlsMutationDocument = graphql(/* GraphQL */ `
  mutation generatePresignedUrls(
    $generatePresignedUrlsInput: GeneratePresignedUrlsInput!
  ) {
    generatePresignedUrls(
      generatePresignedUrlsInput: $generatePresignedUrlsInput
    ) {
      uploadUrl
      fileKey
      publicUrl
    }
  }
`);
